"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdverseMediaScreeningAlternativeProcesses = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.AdverseMediaScreeningAlternativeProcesses = {
    priority: 3,
    label: 'fields.payload.mor_group_answers.adverse_media_screening_alternative_processes.label',
    fallbackLabel: 'Please explain how the risk associated with negative news or reputational risk is managed and whether you have any alternative processes in place to address these risks.',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['mor_group_answers.has_adverse_media_screening', 'contract_onboarding_type'],
    type: Field_type_1.FieldType.String,
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    return payload.mor_group_answers?.has_adverse_media_screening === false
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return payload.mor_group_answers?.has_adverse_media_screening === false
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
